import React from 'react';
import useGoToPage from '../../hooks/useGoToPage';
import pages from '../../routes/pages';
import { ButtonWithText } from '../../components/atoms/Buttons/ButtonWithText';
import useStyle from './SuccessPage.style';

const SuccessPage = () => {
  const classes = useStyle();
  const goToSignIn = useGoToPage(pages.SIGN_IN.path);
  return (
    <div className={classes.root}>
      <h1>Merci pour votre inscription</h1>
      <p>
        Avant de vous connecter, veuillez attendre la validation de nos
        administrateurs. Vous recevrez un e-mail lorsque votre compte sera
        activé.
      </p>
      <ButtonWithText
        content={"Revenir à la page d'accueil"}
        onClick={goToSignIn}
        icon={'RightArrow'}
        iconPosition={'end'}
      />
    </div>
  );
};

export default SuccessPage;
